module.exports = __webpack_public_path__ + "static/media/profile2.5e797f56.png";